export var TABLE_CHECKBOX_CELL_CLASS_PREFIX = 'TableCheckboxCell';
export var tableCheckboxCellRootTestId = 'TableCheckboxCellRoot';
export var TABLE_CHECKBOX_CELL_WIDTH = 48;